import { __rest, __assign } from 'tslib';
import { useRef } from 'react';
import { useEditor as useEditor$1 } from '@tiptap/react';
import useDebouncedCallback from '../../node_modules/use-debounce/esm/useDebouncedCallback.js';
import { useId } from '@reach/auto-id';
import { editorStandardExtensions } from '../extensions/editorStandardExtensions.js';

var defaultFeatures = { links: false };
var useEditor = function (_a) {
    if (_a === void 0) { _a = {}; }
    var defaultContent = _a.defaultContent, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.debounceDuration, debounceDuration = _c === void 0 ? 500 : _c, _d = _a.enableFeatures, enableFeatures = _d === void 0 ? defaultFeatures : _d, height = _a.height, id = _a.id, _e = _a.label, label = _e === void 0 ? "Editor content" : _e, minHeight = _a.minHeight, maxHeight = _a.maxHeight, onUpdateProp = _a.onUpdate, onChange = _a.onChange, _f = _a.placeholder, placeholder = _f === void 0 ? "" : _f, _g = _a.toolbarRef, toolbarRef = _g === void 0 ? useRef(null) : _g, extensionsProp = _a.extensions, props = __rest(_a, ["defaultContent", "disabled", "debounceDuration", "enableFeatures", "height", "id", "label", "minHeight", "maxHeight", "onUpdate", "onChange", "placeholder", "toolbarRef", "extensions"]);
    var editorId = useId(id);
    var extensions = extensionsProp || [
        editorStandardExtensions.configure({
            accessibility: { toolbarElement: toolbarRef },
            link: enableFeatures.links ? undefined : false,
            placeholder: { placeholder: placeholder },
        }),
    ];
    var onUpdate = function (event) {
        var handlers = Array.isArray(onUpdateProp)
            ? onUpdateProp
            : [onUpdateProp];
        handlers.forEach(function (handler) { return handler === null || handler === void 0 ? void 0 : handler(event); });
        onChange === null || onChange === void 0 ? void 0 : onChange(event.editor.getHTML());
    };
    var debouncedOnUpdate = useDebouncedCallback(onUpdate, debounceDuration);
    var editor = useEditor$1(__assign({ 
        // https://github.com/ueberdosis/tiptap/blob/main/packages/core/src/types.ts#L66
        extensions: extensions, content: defaultContent, editable: !disabled, editorProps: {
            attributes: {
                role: "textbox",
                "aria-label": label,
                "aria-multiline": "true",
                "aria-readonly": String(disabled),
            },
        }, onUpdate: debouncedOnUpdate }, props));
    return {
        disabled: disabled,
        editor: editor,
        enableFeatures: enableFeatures,
        editorId: editorId,
        minHeight: height || minHeight,
        maxHeight: height || maxHeight,
        toolbarRef: toolbarRef,
    };
};
var editorOnUpdateHtml = function (handler) {
    var onUpdateHander = function (_a) {
        var editor = _a.editor;
        handler(editor.getHTML());
    };
    return onUpdateHander;
};
var editorOnUpdateJson = function (handler) {
    var onUpdateHander = function (_a) {
        var editor = _a.editor;
        handler(editor.getJSON());
    };
    return onUpdateHander;
};

export { editorOnUpdateHtml, editorOnUpdateJson, useEditor };
//# sourceMappingURL=useEditor.js.map
